import { useEffect, useRef } from "react";

const MANIFEST_HREF = "/admin-manifest.webmanifest";
const SW_HREF = "/admin-sw.js";
const APPLE_ICON = "/pwa/apple-touch-icon.png";

const META = [
  { name: "apple-mobile-web-app-capable", content: "yes" },
  { name: "mobile-web-app-capable", content: "yes" },
  { name: "apple-mobile-web-app-title", content: "DNA Admin" },
  { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" },
  { name: "theme-color", content: "#050505" },
];

function upsertLink(rel, href, extra = {}) {
  let el = document.head.querySelector(`link[data-admin-pwa][rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("data-admin-pwa", "true");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
  Object.entries(extra).forEach(([key, value]) => el.setAttribute(key, value));
  return el;
}

function upsertMeta(name, content) {
  let el = document.head.querySelector(`meta[data-admin-pwa][name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("data-admin-pwa", "true");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
  return el;
}

function removeInjected() {
  document.head.querySelectorAll("[data-admin-pwa]").forEach((node) => node.remove());
}

/**
 * Injects admin-only manifest / Apple tags and registers the scoped SW.
 * Must only be mounted on /admin* routes. Cleans up if the SPA leaves admin.
 */
export default function AdminPwaHead() {
  const registrationRef = useRef(null);

  useEffect(() => {
    upsertLink("manifest", MANIFEST_HREF);
    upsertLink("apple-touch-icon", APPLE_ICON, { sizes: "180x180" });
    META.forEach(({ name, content }) => upsertMeta(name, content));

    let cancelled = false;
    const host = window.location.hostname;
    const registerHere = process.env.NODE_ENV === "production"
      || host === "localhost"
      || host === "127.0.0.1";
    if (registerHere && typeof navigator !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker
        .register(SW_HREF, { scope: "/admin" })
        .then((reg) => {
          if (cancelled) return;
          registrationRef.current = reg;
          window.dispatchEvent(new CustomEvent("dna-admin-sw-ready", { detail: reg }));
        })
        .catch(() => {
          /* installability still works via manifest on iOS; SW is a plus on Chromium */
        });
    }

    return () => {
      cancelled = true;
      removeInjected();
    };
  }, []);

  return null;
}
